import useLogoUrlReplacement from 'components/Dashboard/UserContent/ui/useLogoUrlReplacement';

interface UploadHubLandingPreviewProps {
  organisationLogo: string | null;
  backgroundColour: string;
  barBackgroundColour: string;
}

const UploadHubLandingPreview = (props: UploadHubLandingPreviewProps) => {
  const { organisationLogo, backgroundColour, barBackgroundColour } = props ?? {};
  const { clientLogoReplacement } = useLogoUrlReplacement();
  const logoUrl = organisationLogo?.startsWith('data:')
    ? organisationLogo
    : clientLogoReplacement({ organisationLogo });

  return (
    <div className='rounded border p-3' style={{ backgroundColor: backgroundColour }}>
      {organisationLogo && (
        <img
          src={logoUrl}
          alt='Organisation logo'
          className='rounded bg-white mb-3'
          style={{ width: '28px', height: '28px', objectFit: 'contain' }}
        />
      )}
      <div className='rounded overflow-hidden'>
        <div style={{ backgroundColor: barBackgroundColour, height: '18px' }} />
        <div className='bg-white flex-centered justify-content-center' style={{ height: '142px' }}>
          <p className='mb-0 main-light-text'>Your file</p>
        </div>
      </div>
    </div>
  );
};

export default UploadHubLandingPreview;
